import type { ValueOf } from 'type-fest';

import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { FindOrCreateDraftDataQuery, FindOrCreateDraftDataQueryVariables } from './api.graphql';
import { FindOrCreateDraftData } from './api.graphql';

type ExperimentNames = ValueOf<FindOrCreateDraftDataQuery['experiments']>['experimentName'];
function getExperimentFallback(experimentName: ExperimentNames) {
	return {
		variation: 'control',
		type: 'experiment-service',
		experimentName,
		config: {},
		treated: false,
	} as const;
}

export async function getFindOrCreateDraftData({ fetch }: UtilityContext['gql']): Promise<FindOrCreateDraftDataQuery> {
	try {
		const { data } = await fetch<FindOrCreateDraftDataQuery, FindOrCreateDraftDataQueryVariables>({
			query: FindOrCreateDraftData,
			rejectOnError: true,
		});

		return data;
	} catch {
		return {
			experiments: {
				starfishSap3RecommendedAngles: getExperimentFallback('starfish_sap3_recommended_angles'),
			},
		};
	}
}
